const _ = require("lodash");
const moment = require("moment");

// TODO: copied from TrainerCore.js. Find a better shared home for this
// function. (Requiring TrainerCore from here can cause weird issues with
// migrations needing to require shared db files that haven't been made yet
// when the CI runs the migrations.)
const getDateTimeString = function(mmt) {
	return mmt.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
};

const getUserTimeZone = function(userTime) {
	const timeZone = moment.parseZone(userTime).utcOffset() / 60;
	return timeZone;
};

const getTimeUpdates = function(columnName, userTime, serverTime) {
	const serverMoment = serverTime ? moment.parseZone(serverTime) : moment();
	//TODO: What should happen if userTime is null/missing?
	const timeZone = getUserTimeZone(userTime);
	return {
		[columnName]: getDateTimeString(serverMoment),
		[columnName + "TZ"]: timeZone,
	};
};

const getFormattedString = function(serverTime) {
	return getDateTimeString(moment(serverTime));
};

const getFormattedServerTime = function() {
	return getDateTimeString(moment());
};

// Given a userTime, calculates the date (a string in the form YYYY-MM-DD) it
// currently is in the user's timezone. Second parameter is optional and
// defaults to current time.
const getUserTodayDate = function(userTime, now) {
	return moment(now)
		.utcOffset(moment.parseZone(userTime).utcOffset())
		.format("YYYY-MM-DD");
};

//Given a serverTime and the user's timezone in offset hours,
//calculates the date (a string in the form YYYY-MM-DD) of the server time in the user's timezone
const getUserDate = function(serverTime, userTimeZone) {
	return moment(serverTime)
		.add(userTimeZone, "hours")
		.format("YYYY-MM-DD");
};

//Checks if the time is at least numMinutes before the current time
const isNumMinutesPast = function(time, numMinutes) {
	return moment().diff(moment(time), "minutes") >= numMinutes;
};

// Pass a process.hrtime return and get a prettier seconds.milliseconds
// format for logging.
const getHrTime = function(hrTime) {
	let s = hrTime[0];
	let ms = Math.round(hrTime[1] / 1000000);
	if (ms >= 1000) {
		s += 1;
		ms -= 1000;
	}
	return s + "." + _.padStart(ms, 3, "0");
};

// Returns the time difference formatted as __m __s (minutes, seconds).
const getMSDuration = function(start, end) {
	start = +start;
	end = +end || Date.now();
	const dur = moment.duration(end - start);
	const durStr = `${Math.floor(dur.asMinutes())}m ${dur.seconds()}s`;
	return durStr;
};

module.exports = {
	getDateTimeString,
	getUserTimeZone,
	getTimeUpdates,
	getFormattedString,
	getFormattedServerTime,
	getUserTodayDate,
	getUserDate,
	isNumMinutesPast,
	getHrTime,
	getMSDuration,
};
